import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="contact" className="bg-accent-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-5">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-briefcase-line text-white text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white">
                Vietnam<span className="text-primary-400">.cv</span>
              </span>
            </Link>
            <p className="text-accent-200 text-sm leading-relaxed mb-5">
              Nền tảng kết nối việc làm hàng đầu Việt Nam. Cập nhật hàng ngàn việc làm chất lượng mỗi ngày.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-accent-600 rounded-lg text-accent-300 hover:text-white hover:border-primary-400 transition-all cursor-pointer">
                <i className="ri-facebook-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-accent-600 rounded-lg text-accent-300 hover:text-white hover:border-primary-400 transition-all cursor-pointer">
                <i className="ri-linkedin-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center border border-accent-600 rounded-lg text-accent-300 hover:text-white hover:border-primary-400 transition-all cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-5">
              Việc làm theo ngành
            </h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Công nhân sản xuất</a></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Xây dựng</a></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Vận tải - Giao hàng</a></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Nhà hàng - Khách sạn</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-5">
              Hỗ trợ
            </h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Trung tâm trợ giúp</a></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Hướng dẫn tìm việc</a></li>
              <li><Link to="/dieu-khoan-su-dung" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Quy chế hoạt động</Link></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Liên hệ hỗ trợ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-5">
              Về chúng tôi
            </h4>
            <ul className="space-y-3">
              <li><Link to="/gioi-thieu" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Giới thiệu</Link></li>
              <li><a href="#" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Tuyển dụng nhân sự</a></li>
              <li><Link to="/chinh-sach-bao-mat" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Chính sách bảo mật</Link></li>
              <li><Link to="/dieu-khoan-su-dung" className="text-accent-200 text-sm hover:text-white transition-colors no-underline">Điều khoản sử dụng</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-accent-700/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-accent-300 text-xs">
              &copy; 2026 Vietnam.cv. Tất cả quyền được bảo lưu.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/chinh-sach-bao-mat" className="text-accent-300 text-xs hover:text-white transition-colors no-underline">Chính sách bảo mật</Link>
              <Link to="/dieu-khoan-su-dung" className="text-accent-300 text-xs hover:text-white transition-colors no-underline">Điều khoản sử dụng</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}